import ViewController from "core/views/view.controller";
import User from "../../model/user.model";
import Branch from "../../model/branch.model";

export default class SettingsCtrl extends ViewController {
    static $inject = ['$scope', '$state', '$ionicPopup', '$translate', 'Branches', 'settings', 'CacheFactory'];

    constructor() {
        super(...arguments);
        this.branch = null;
        this.branches = [];
    }

    $onViewEnter() {
        this.branch = this.settings.branch;

        this.Branches.all().then((branches)=> {
            this.branches = branches;
        });
    }

    save() {
        this.settings.branch = this.branch;
        this.settings.save();
    }

    showLogoutConfirmation() {
        this.$translate([
            'LOGOUT_TITLE',
            'LOGOUT_CONFIRMATION',
            'CANCEL',
            'YES'

        ]).then((translations) => {
            this.$ionicPopup.confirm({
                title: translations.LOGOUT_TITLE,
                template: translations.LOGOUT_CONFIRMATION,
                cancelType: 'button-balanced button-clear',
                cancelText: translations.CANCEL,
                okType: 'button-stable button-clear',
                okText: translations.YES

            }).then((res) => {
                if (res) {
                    this.logout();
                }
            });
        });
    }

    logout() {
        this.settings.reset();
        this.settings.save();

        this.CacheFactory.clearAll();
        this.$state.go('login');
    }

    updateCalendarFirstHour() {
        let maxHour = this.settings.calendarLastHour - 1;

        if (this.settings.calendarFirstHour > maxHour) {
            this.settings.calendarFirstHour = maxHour;
        }
    }

    updateCalendarLastHour() {
        let maxHour = this.settings.calendarFirstHour + 1;

        if (this.settings.calendarLastHour < maxHour) {
            this.settings.calendarLastHour = maxHour;
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/views/settings/settings.controller.js